import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';

function initialState () {
  return {
    list: null,
  };
}

const state = initialState ();

// getters
const getters = {
  getField,
  list: state => {
    return state.list;
  },
  homepage: state => {
    /* For portfolio website, there would be only one homepage, that's why picking up zero index page */
    let homepage = state.list ? state.list[0] : null;
    if(homepage && !homepage.widget_ids){
      homepage.widget_ids = [];
    }
    return homepage;
  }
};

// actions
const actions = {
  /** Get all pages */
  async list (context, payload) {
    var response = await API.adminPage.list (payload);
    context.commit ('set_list', {
        pages: response.pages,
    });
    return response;
  },
  async get (context, payload) {
    var response = await API.adminPage.get (payload);
    return response;
  },
  async update(context, payload) {
    var response = await API.adminPage.update(payload);
    return response;
  },
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

  set_list (state, payload) {
    state.list = payload.pages;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
